var React = require('react');

function MinusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22,10.7c0-0.8-0.7-1.4-1.5-1.4H3.4C2.6,9.4,2,10,2,10.7v2.7c0,0.8,0.6,1.4,1.4,1.4h17.2c0.7,0,1.4-0.6,1.4-1.4V10.7L22,10.7z"}));
}

MinusIcon.defaultProps = {"data-dmid":"dm-minus","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","fill":"currentColor","pointerEvents":"none","color":"color2"};

module.exports = MinusIcon;

MinusIcon.default = MinusIcon;
